import { createAction, props } from '@ngrx/store';

export const STATE_RESTORED = createAction('@briebug/storage-sync/state-restored', props<{ restoredState: any }>());

export const STATE_STORED = createAction('@briebug/storage-sync/state-stored', props<{ storedState: any }>());
